import global from "./global";
import store from '../store/'
import router from '../router/'
import tool from "./tool"
import {Toast} from "vant";


const Util = {
    encryptPhone(phone){
        if(!phone){
            return phone;
        }
        phone = phone + "";
        return phone.substr(0,4) + '***' + phone.substr(7,4);
    },
    inArray(search,array){
        for(var i in array){
            if(array[i]==search){
                return true;
            }
        }
        return false;
    },
    autoImage(src){
        var host = global.DIST_IMAGE_HOST;
        if(this.isBeta()){
            host = global.DEV_IMAGE_HOST;
        }
        if(this.isUat()){
            host = global.UAT_IMAGE_HOST;
        }
        if(!src){return '';}
        if(src.indexOf('http') > -1){
            return src;
        }else{
            return host+src;
        }
    },
    setAccessToken(access_token){
        tool.storage.setCookie('dtf_access_token',access_token,5)
    },
    getAccessToken(){
        return tool.storage.getCookie('dtf_access_token') ? tool.storage.getCookie('dtf_access_token') : ''
    },
    setGuestUid(guest_id){
        tool.storage.setLocal('guest_uid',guest_id)
    },
    getGuestUid(){
        return tool.storage.getLocal('guest_uid')
    },
    showBottom(show_bottom){
        store.commit('setShowBottom',show_bottom)
    },
    showAuth(option){
        store.commit('setShowAuth',option)
    },
    showWait(show_wait){
        store.commit('setShowWait',show_wait)
    },
    toLink(link,query = {},target = ""){
        if(link.indexOf('http') > -1){
            if(target == '_blank'){
                window.open(link)
            }else{
                window.location.href = link;
            }
        }else{
            router.push({
                path:link,
                query:query
            })
        }
    },
    toBack(){
        var backUrl = tool.other.getUrlParams('backUrl');
        if(backUrl){
            backUrl = decodeURIComponent(decodeURIComponent(backUrl));
            setTimeout(()=>{
                window.location = backUrl;
            },300)
        }else{
            var from = router.currentRoute.query.from || '/';
            if(from == '/login' || from == '/register'){
                from = "/"
            }
            if(from.indexOf('http') > -1){
                window.location.href = from;
            }else{
                router.replace({
                    path:from
                })
            }
        }
    },
    setDellCookie(){
        var user = store.state.user_info;
        var name = "smarketMember_498";
        var value = encodeURIComponent(JSON.stringify({
            session:user.session,
            memberId:Number(user.loginId),
            name:user.username,
            enteredId:user.enteredId,
            mobile:this.encryptPhone(user.mobile),
            year: 2026
        }));
        console.log(value);

        var oDate = new Date();
        oDate.setDate(oDate.getDate() + 5);
        var domain = "dellemc-solution.com";
        document.cookie = name + '=' + value + ';expires=' + oDate.toGMTString() + ';domain='+domain+';path=/';
        // var domain2 = "dellemc-solution.com";
        // var name2 = "smarketDtfMember_498";
        // document.cookie = name2 + '=' + value + ';expires=' + oDate.toGMTString() + ';domain='+domain2+';path=/';
    },
    toIframe(src,param = {}){
        param.src = src;
        router.push({
            path:'/live',
            query:param
        })
    },
    //线下会
    isOffline(){
        return window.location.pathname.includes('dtf-2026');
        //return window.location.host === "dtf-2024.dellemc-solution.com" || window.location.host === "dtf-2024-test.dellemc-solution.com" || window.location.host === "dtf-offline.dellemc-solution.com" || window.location.hostname === "local.dtf2024.dellemc-solution.com";
    },
    isMobile(){
        var is_mobile = false;
        var ua = navigator.userAgent.toLowerCase();
        if (/mobile|android|iphone|ipad|phone/i.test(ua)) {
            is_mobile = true;
        }
        return is_mobile;
    },
    isWeiXin(){
        var ua = navigator.userAgent.toLowerCase();
        return /micromessenger/.test(ua);
    },
    isIE() {
        if(!!window.ActiveXObject || "ActiveXObject" in window){
            return true;
        }else{
            return false;
        }
    },
    isIos() {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {//安卓手机
            return false
        } else if (u.indexOf('iPhone') > -1) {//苹果手机
            return true
        } else if (u.indexOf('iPad') > -1) {//iPad
            return false
        } else if (u.indexOf('Windows Phone') > -1) {//winphone手机
            return false
        } else {
            return false
        }
    },
    checkStr (str, type) {
        switch (type) {
            case 'phone':   //手机号码
                return /^1[1|2|3|4|5|6|7|8|9][0-9]{9}$/.test(str);
            case 'tel':     //座机
                return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
            case 'card':    //身份证
                return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str);
            case 'pwd':     //密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
                return /^[a-zA-Z]\w{5,17}$/.test(str)
            case 'postal':  //邮政编码
                return /[1-9]\d{5}(?!\d)/.test(str);
            case 'QQ':      //QQ号
                return /^[1-9][0-9]{4,9}$/.test(str);
            case 'email':   //邮箱
                return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
            case 'money':   //金额(小数点2位)
                return /^\d*(?:\.\d{0,2})?$/.test(str);
            case 'URL':     //网址
                return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str)
            case 'IP':      //IP
                return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str);
            case 'date':    //日期时间
                return /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) || /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
            case 'number':  //数字
                return /^[0-9]$/.test(str);
            case 'english': //英文
                return /^[a-zA-Z]+$/.test(str);
            case 'chinese': //中文
                return /^[\u4E00-\u9FA5]+$/.test(str);
            case 'lower':   //小写
                return /^[a-z]+$/.test(str);
            case 'upper':   //大写
                return /^[A-Z]+$/.test(str);
            case 'HTML':    //HTML标记
                return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
            default:
                return true;
        }
    },
    isBeta(){
        return window.location.host.includes("local")
        // return window.location.host != 'dtf2024.dellemc-solution.com' && window.location.host != 'dtf-2024.dellemc-solution.com' && window.location.host != 'dtf.dellemc-solution.com' && window.location.host != 'dtf-offline.dellemc-solution.com';
    },
    isUat(){
        return window.location.host.includes("uat")
        // return window.location.host === 'dtf2024-test.dellemc-solution.com' || window.location.host === 'dtf-2024-test.dellemc-solution.com';
    },
    version(){
        if(window.location.host == 'dtf.dellemc-solution.com' || (window.location.host == 'case.hnsw.vip' && window.location.pathname == '/dell/')){
            return 1;
        }else{
            return 2;
        }
    },
    isDevelopment(){
        return process.env.NODE_ENV !== 'development' ? false : true;
    },
    rootPath() {
        let curWwwPath = window.document.location.href;
        let pathName = window.document.location.pathname;
        let pos = curWwwPath.indexOf(pathName);
        let localhostPath = curWwwPath.substring(0, pos);
        let projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
        return (localhostPath + projectName + "/");
    },
    setCookie (name, value, day) {
        var setting = arguments[0];
        var o_Date;
        if (Object.prototype.toString.call(setting).slice(8, -1) === 'Object'){
            for (var i in setting) {
                o_Date = new Date();
                o_Date.setDate(o_Date.getDate() + day);
                document.cookie = i + '=' + setting[i] + ';expires=' + o_Date;
            }
        }else{
            o_Date = new Date();
            o_Date.setDate(o_Date.getDate() + day);
            document.cookie = name + '=' + value + ';expires=' + o_Date;
        }
    },
    getCookie (name) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');
            if (arr2[0] == name) {
                return arr2[1];
            }
        }
        return '';
    },
    removeCookie (name) {
        this.setCookie(name, 1, -1);
    },
    getUrlParams(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = decodeURI(window.location.search).substr(1).match(reg);
        if(r!=null) return  r[2]; return null;
    },
}

export default Util;
